import { render, staticRenderFns } from "./management-edition-parameters.component.vue?vue&type=template&id=6dccd049&scoped=true&"
import script from "./management-edition-parameters.component.vue?vue&type=script&lang=ts&"
export * from "./management-edition-parameters.component.vue?vue&type=script&lang=ts&"
import style0 from "./management-edition-parameters.component.vue?vue&type=style&index=0&id=6dccd049&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dccd049",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
